import { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

import { BsLightningChargeFill, BsStarFill, BsGridFill, BsListUl } from 'react-icons/bs';
import { IoFlash } from 'react-icons/io5';
import { MdCable, MdElectricBolt, MdOutlineWbIncandescent, MdSensors } from 'react-icons/md';
import { GiElectric } from 'react-icons/gi';
import { TbSwitchHorizontal, TbPlug } from 'react-icons/tb';
import { FiArrowRight, FiTool } from 'react-icons/fi';

import img1    from "../assets/1.webp";
import img2    from "../assets/2.avif";
import unarm   from "../assets/unarm.png";
import cat6    from "../assets/cat6.webp";
import tv      from "../assets/TV.jpg";
import flexi   from "../assets/felxi.jpg";
import teli    from "../assets/teli.jpg";
import pipe    from "../assets/pipe.jpg";
import pipe2   from "../assets/pipe2.jpg";
import junction from "../assets/junction.jpg";
import band    from "../assets/band.jpg";
import cement  from "../assets/cement.jpg";
import hooks   from "../assets/hooks.jpg";
import db      from "../assets/DB.jpg";
import mcb     from "../assets/MCB.jpg";
import elcb    from "../assets/ELCB.jpg";
import iso     from "../assets/iso.jpg";
import bar     from "../assets/bar.jpg";
import sw      from "../assets/switch.jpg";
import modular from "../assets/modular.jpg";
import fan     from "../assets/Fan-Regulator.jpg";
import box     from "../assets/Concealed-Modular-Boxes.jpg";
import plate   from "../assets/Cover-Plates.jpg";
import holder  from "../assets/bulb-holder.jpg";
import rose    from "../assets/Ceiling-Rose.jpg";
import bell    from "../assets/bell.jpg";
import earthRod  from "../assets/earthing-rod.webp";
import earthWire from "../assets/earthing-wire.jpg";
import earthChem from "../assets/earthing-compound.jpg";
import tape    from "../assets/tape.jpg";
import tie     from "../assets/tie.webp";
import screw   from "../assets/screw.jpg";
import plug    from "../assets/plug.jpg";

/* ================= CATEGORIES ================= */
const categories = [
  { label: 'All',              icon: <BsLightningChargeFill /> },
  { label: 'Wiring & Cables',  icon: <MdCable /> },
  { label: 'Conduit & Piping', icon: <FiTool /> },
  { label: 'Switchgear',       icon: <MdElectricBolt /> },
  { label: 'Modular Switches', icon: <TbSwitchHorizontal /> },
  { label: 'Lighting Points',  icon: <MdOutlineWbIncandescent /> },
  { label: 'Earthing',         icon: <GiElectric /> },
  { label: 'Miscellaneous',    icon: <TbPlug /> },
];

const allProducts = [
  // ── Wiring & Cables ──────────────────────────────────────────
  { img: img1,    name: 'House Wire – FR 1.0 / 1.5 / 2.5 / 4.0 / 6.0 mm²', desc: 'Flame-retardant copper conductor house wires available in all standard gauges. ISI marked.', cat: 'Wiring & Cables', badge: 'bestseller' },
  { img: img2,    name: 'Armoured Cable (SWA)',                               desc: 'Steel wire armoured cable for main incoming supply, underground and outdoor runs.',           cat: 'Wiring & Cables' },
  { img: unarm,   name: 'Unarmoured Main Incoming Cable',                     desc: 'PVC insulated unarmoured cables for protected indoor main incoming connections.',              cat: 'Wiring & Cables' },
  { img: cat6,    name: 'CAT6 LAN Cable',                                     desc: 'High-speed Cat6 UTP / FTP data cable for networking and home-office installations.',         cat: 'Wiring & Cables' },
  { img: tv,      name: 'Coaxial TV Cable (RG6)',                             desc: 'RG6 coaxial cable for DTH, cable TV, and CCTV antenna connections.',                        cat: 'Wiring & Cables' },
  { img: flexi,   name: 'Flexible Wire (Multi-strand)',                       desc: 'Multi-strand flexible wire for hanging lights, appliances, and panel wiring.',               cat: 'Wiring & Cables' },
  { img: teli,    name: 'Telephone Cable',                                    desc: '2-pair and 4-pair telephone cables for landline and intercom wiring.',                       cat: 'Wiring & Cables' },

  // ── Conduit & Piping ─────────────────────────────────────────
  { img: pipe,    name: 'PVC Conduit Pipe (Heavy / Medium)',   desc: 'Rigid PVC conduit pipes for concealed and surface wiring. Available in 20mm, 25mm, 32mm.', cat: 'Conduit & Piping', badge: 'popular' },
  { img: pipe2,   name: 'Flexible Corrugated Pipe',            desc: 'Flexible conduit for slab-to-wall transitions and tight-bend runs.',                        cat: 'Conduit & Piping' },
  { img: junction,name: 'Junction Boxes (Deep & Shallow)',     desc: 'GI and PVC junction boxes for wire joints and conduit intersection points.',                cat: 'Conduit & Piping' },
  { img: band,    name: 'Conduit Bends, Couplers & Tees',      desc: 'Full range of conduit fittings — 90° bends, straight couplers, and T-junctions.',          cat: 'Conduit & Piping' },
  { img: cement,  name: 'PVC Solvent Cement',                  desc: 'Fast-bonding solvent cement for all PVC conduit and pipe joints.',                         cat: 'Conduit & Piping' },
  { img: hooks,   name: 'Fan Hooks (MS / Mild Steel)',         desc: 'Heavy-duty slab fan hooks for ceiling fans. Pre-galvanised for rust resistance.',           cat: 'Conduit & Piping' },

  // ── Switchgear & Protection ──────────────────────────────────
  { img: db,   name: 'Distribution Board (DB Box)',  desc: 'Metal and PVC distribution boards for domestic and commercial electrical panels.',         cat: 'Switchgear', badge: 'bestseller' },
  { img: mcb,  name: 'MCB – Single & Double Pole',   desc: 'Miniature circuit breakers (6A–63A) with high-breaking capacity. ISI certified.',          cat: 'Switchgear' },
  { img: elcb, name: 'RCCB / ELCB',                  desc: 'Residual current and earth-leakage circuit breakers for shock and fire protection.',        cat: 'Switchgear' },
  { img: iso,  name: 'Isolator (Main Switch)',        desc: 'DP and TPN isolators for safely disconnecting supply. Available 32A–200A.',                 cat: 'Switchgear' },
  { img: bar,  name: 'Busbar (Copper / Aluminium)',  desc: 'Copper and aluminium busbars for heavy load distribution inside DB panels.',                cat: 'Switchgear' },

  // ── Modular Switches & Accessories ──────────────────────────
  { img: sw,      name: 'Modular Switches (6A / 16A / 25A)',     desc: 'One-way, two-way, and intermediate modular switches with anti-bacterial finish.',  cat: 'Modular Switches', badge: 'popular' },
  { img: modular, name: 'Modular Sockets (3-pin & 5-pin)',        desc: '6A and 16A modular sockets with child-safety shutters. ISI certified.',           cat: 'Modular Switches' },
  { img: fan,     name: 'Fan Regulator (Step-type)',              desc: '5-step capacitor fan regulators for energy-saving ceiling fan speed control.',    cat: 'Modular Switches' },
  { img: box,     name: 'Concealed Modular Boxes (1M–18M)',       desc: 'PVC and MS concealed gang boxes in 1, 2, 3, 4, 6, 8, 12, and 18-module sizes.', cat: 'Modular Switches' },
  { img: plate,   name: 'Cover Plates & Blank Plates',            desc: 'Modular front cover plates and blank/dummy plates to finish switch boards neatly.', cat: 'Modular Switches' },

  // ── Lighting & Ceiling Points ────────────────────────────────
  { img: holder, name: 'Bulb Holders – Angle & Batten', desc: 'Porcelain and PVC bulb holders in B22 and E27 fittings for all ceiling points.',        cat: 'Lighting Points' },
  { img: rose,   name: 'Ceiling Rose',                  desc: 'Standard 3-terminal ceiling roses for safe pendant light connections.',                  cat: 'Lighting Points' },
  { img: holder, name: 'LED Driver / Choke',            desc: 'Constant current LED drivers and electronic chokes for tube lights and panels.',         cat: 'Lighting Points' },
  { img: bell,   name: 'Bell Push Switch & Door Bell',  desc: 'Flush and surface-mount bell push switches with matching electronic door bells.',        cat: 'Lighting Points' },

  // ── Earthing Material ────────────────────────────────────────
  { img: earthRod,  name: 'Earthing Rod – Copper / GI',          desc: 'Copper-bonded and galvanised iron earth electrodes for domestic and industrial earthing pits.', cat: 'Earthing', badge: 'new' },
  { img: earthWire, name: 'Earthing Wire – Green / Bare Copper', desc: 'Multi-strand bare copper and green-insulated earth wires in 4mm² to 16mm².',               cat: 'Earthing' },
  { img: earthChem, name: 'Chemical Earthing Compound',          desc: 'Low-resistance backfill compound (charcoal, salt, and chemical powder) for efficient earth pits.', cat: 'Earthing' },

  // ── Miscellaneous ────────────────────────────────────────────
  { img: tape,  name: 'PVC Insulation Tape',       desc: 'Flame-retardant PVC electrical insulating tape in standard and wider widths.',              cat: 'Miscellaneous', badge: 'popular' },
  { img: tie,   name: 'Cable Ties (Nylon)',         desc: 'UV-stabilised nylon cable ties in multiple lengths for cable dressing and bundling.',        cat: 'Miscellaneous' },
  { img: screw, name: 'Screws & Rawl Plugs',        desc: 'MS screws, self-tapping screws, and nylon rawl plugs for conduit and switch box fixing.',    cat: 'Miscellaneous' },
  { img: plug,  name: '3-Pin Plug Top (6A & 16A)', desc: 'ISI-marked rewireable 3-pin plug tops in 6A and 16A ratings for appliances.',               cat: 'Miscellaneous' },
];

export default function Products() {
  const [active, setActive] = useState('All');
  const [gridView, setGridView] = useState(true);

  const filtered = active === 'All' ? allProducts : allProducts.filter(p => p.cat === active);

  return (
    <div className="page-wrapper">

      {/* HERO */}
      <section className="page-hero bg-grid">
        <div className="page-hero-inner container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="breadcrumb-sep">›</span>
            <span>Products</span>
          </div>
          <div className="tag"><span className="tag-dot" /> Our Catalogue</div>
          <h1 className="page-hero-title">OUR <span>PRODUCTS</span></h1>
          <p className="page-hero-desc">Complete range of electrical wiring materials, switchgear, and accessories — all ISI certified.</p>
          <div className="page-hero-line" />
        </div>
      </section>

      {/* PRODUCTS */}
      <section className="section">
        <div className="container">

          {/* FILTERS */}
          <div style={{ display:'flex', justifyContent:'space-between', flexWrap:'wrap', gap:16, marginBottom:32 }}>
            <div className="filter-tabs">
              {categories.map(c => (
                <button
                  key={c.label}
                  className={`filter-tab${active === c.label ? ' active' : ''}`}
                  onClick={() => setActive(c.label)}
                >
                  {c.icon} {c.label}
                </button>
              ))}
            </div>
            <div style={{ display:'flex', gap:8 }}>
              <button className={`filter-tab${gridView ? ' active' : ''}`}  onClick={() => setGridView(true)}><BsGridFill /></button>
              <button className={`filter-tab${!gridView ? ' active' : ''}`} onClick={() => setGridView(false)}><BsListUl /></button>
            </div>
          </div>

          {/* ── GRID VIEW ── */}
          {gridView ? (
            <div className="prd-grid">
              {filtered.map((p, i) => (
                <div key={i} className="prd-card" style={{ animationDelay:`${i*0.06}s` }}>

                  {/* Badge */}
                  {p.badge && <span className={`product-badge ${p.badge}`}>{p.badge}</span>}

                  {/* Image */}
                  <div className="prd-img-wrap">
                    <img src={p.img} alt={p.name} className="prd-img" loading="lazy" />
                    <div className="prd-cat-chip">
                      <BsLightningChargeFill style={{ fontSize:'.6rem' }} /> {p.cat}
                    </div>
                  </div>

                  {/* Body */}
                  <div className="prd-body">
                    <div className="prd-name">{p.name}</div>
                    <p className="prd-desc">{p.desc}</p>
                    <div className="prd-footer">
                      <div className="product-stars">
                        {[...Array(5)].map((_,j) => <BsStarFill key={j} />)}
                      </div>
                      <button className="product-enquire"><IoFlash /> Enquire</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          ) : (
            /* ── LIST VIEW ── */
            <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
              {filtered.map((p, i) => (
                <div key={i} className="prd-list-row" style={{ animationDelay:`${i*0.05}s` }}>

                  {/* Thumbnail */}
                  <div className="prd-list-thumb">
                    <img src={p.img} alt={p.name} className="prd-list-img" loading="lazy" />
                  </div>

                  {/* Info */}
                  <div className="prd-list-info">
                    <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4, flexWrap:'wrap' }}>
                      {p.badge && (
                        <span className={`product-badge ${p.badge}`}
                          style={{ position:'static', fontSize:'.68rem', padding:'2px 10px' }}>
                          {p.badge}
                        </span>
                      )}
                      <span className="prd-list-cat">
                        <BsLightningChargeFill style={{ fontSize:'.6rem' }} /> {p.cat}
                      </span>
                    </div>
                    <div className="prd-list-name">{p.name}</div>
                    <p className="prd-list-desc">{p.desc}</p>
                  </div>

                  {/* Action */}
                  <div className="prd-list-action">
                    <div className="product-stars" style={{ fontSize:'.65rem' }}>
                      {[...Array(5)].map((_,j) => <BsStarFill key={j} />)}
                    </div>
                    <button className="product-enquire"><IoFlash /> Enquire</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">CAN'T FIND WHAT YOU <span style={{ color:'var(--primary)' }}>NEED?</span></h2>
          <p className="cta-desc">We source any electrical item on request — just tell us the spec.</p>
          <div className="cta-actions">
            <Link to="/contact" className="btn-primary"><IoFlash /> Request a Product</Link>
            <Link to="/services" className="btn-outline"><FiArrowRight /> Our Services</Link>
          </div>
        </div>
      </section>

      {/* ── Scoped styles ── */}
      <style>{`

        /* ===== GRID ===== */
        .prd-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
          gap: 24px;
          align-items: stretch;
        }

        /* ===== CARD ===== */
        .prd-card {
          background: var(--card-bg);
          border: 1.5px solid var(--card-border);
          border-radius: var(--radius-lg);
          overflow: hidden;
          display: flex;
          flex-direction: column;       /* stack: image → body */
          position: relative;
          transition: var(--transition);
          box-shadow: var(--shadow);
          opacity: 0;
          animation: fadeInUp 0.55s ease forwards;
          cursor: pointer;
        }
        .prd-card::before {
          content: '';
          position: absolute; top: 0; left: 0; right: 0; height: 3px;
          background: linear-gradient(90deg, var(--primary), var(--navy));
          transform: scaleX(0); transform-origin: left;
          transition: var(--transition);
          z-index: 2;
        }
        .prd-card:hover {
          transform: translateY(-6px);
          border-color: var(--card-border-h);
          box-shadow: var(--shadow-lg), var(--glow);
        }
        .prd-card:hover::before { transform: scaleX(1); }

        /* ===== IMAGE WRAPPER ===== */
        .prd-img-wrap {
          position: relative;
          width: 100%;
          height: 200px;          /* fixed height — all images same */
          overflow: hidden;
          background: var(--bg-alt);
          flex-shrink: 0;         /* never squish the image */
        }
        .prd-img {
          width: 100%;
          height: 100%;
          object-fit: cover;      /* fills the box, crops excess */
          object-position: center;
          display: block;
          transition: transform 0.5s ease;
        }
        .prd-card:hover .prd-img { transform: scale(1.07); }

        /* ===== CATEGORY CHIP ===== */
        .prd-cat-chip {
          position: absolute; top: 12px; left: 12px;
          background: rgba(13,148,136,0.88);
          backdrop-filter: blur(6px);
          border: 1px solid rgba(13,148,136,0.5);
          border-radius: 20px; padding: 4px 12px;
          font-family: 'Rajdhani', sans-serif;
          font-weight: 600; font-size: .7rem;
          letter-spacing: 1.5px; text-transform: uppercase;
          color: #fff;
          display: flex; align-items: center; gap: 5px;
        }

        /* ===== CARD BODY ===== */
        .prd-body {
          padding: 18px 20px 20px;
          display: flex;
          flex-direction: column;
          flex: 1;                /* grows to fill remaining card height */
        }
        .prd-name {
          font-family: 'Rajdhani', sans-serif;
          font-weight: 700; font-size: 1rem;
          letter-spacing: 0.4px;
          color: var(--navy);
          margin-bottom: 8px;
          line-height: 1.35;
          /* clamp to 2 lines so all cards look uniform */
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .prd-desc {
          font-size: 0.83rem;
          color: var(--text-muted);
          line-height: 1.6;
          flex: 1;               /* pushes footer to bottom */
          margin-bottom: 16px;
          /* clamp to 3 lines */
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .prd-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          margin-top: auto;      /* guarantee bottom alignment */
        }

        /* ===== LIST ROW ===== */
        .prd-list-row {
          display: flex;
          align-items: center;
          gap: 0;
          background: var(--card-bg);
          border: 1.5px solid var(--card-border);
          border-radius: var(--radius-lg);
          overflow: hidden;
          transition: var(--transition);
          opacity: 0;
          animation: fadeInUp 0.5s ease forwards;
        }
        .prd-list-row:hover {
          border-color: var(--card-border-h);
          transform: translateX(4px);
          box-shadow: var(--shadow);
        }
        .prd-list-thumb {
          flex-shrink: 0;
          width: 120px;
          height: 96px;
          overflow: hidden;
          background: var(--bg-alt);
        }
        .prd-list-img {
          width: 100%; height: 100%;
          object-fit: cover; object-position: center;
          display: block;
          transition: transform 0.4s ease;
        }
        .prd-list-row:hover .prd-list-img { transform: scale(1.08); }

        .prd-list-info {
          flex: 1;
          padding: 14px 16px;
          min-width: 0;           /* prevents overflow in flex */
        }
        .prd-list-cat {
          font-family: 'Rajdhani', sans-serif;
          font-weight: 600; font-size: .7rem;
          letter-spacing: 1.5px; text-transform: uppercase;
          color: var(--primary);
          display: inline-flex; align-items: center; gap: 4px;
        }
        .prd-list-name {
          font-family: 'Rajdhani', sans-serif;
          font-weight: 700; font-size: .95rem;
          color: var(--navy); margin-bottom: 4px;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }
        .prd-list-desc {
          font-size: .8rem; color: var(--text-muted);
          line-height: 1.55;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
        }
        .prd-list-action {
          flex-shrink: 0;
          padding: 0 20px;
          display: flex; flex-direction: column;
          align-items: center; gap: 10px;
        }

        /* ===== RESPONSIVE ===== */
        @media (max-width: 600px) {
          .prd-grid {
            grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
            gap: 14px;
          }
          .prd-img-wrap { height: 150px; }
          .prd-body     { padding: 14px 14px 16px; }
          .prd-name     { font-size: .9rem; }

          .prd-list-thumb { width: 90px; height: 80px; }
          .prd-list-action { padding: 0 12px; }
        }
      `}</style>

      <Footer />
    </div>
  );
}